import { Text, VStack, Box } from "@chakra-ui/react";
import { SYLA_EARLIEST_EVENT_DATE } from "@syla/shared/types/helpers/constants";
import React from "react";
import { AccountTimeZone } from "../../../constants/AccountTimeZone";
import { useGetAccountFinancialYearsData } from "../../../store/actions/userFinancialYear";
import { DatePicker } from "../../atoms/datePicker/DatePicker";
import { DatePreset } from "../../atoms/datePicker/DatePickerPresetsDropdown";
import { startOfDayInTimeZone } from "../../atoms/datePicker/tzDateUtils";

export function BalancesDatePicker({
  date,
  onChange,
}: {
  date: Date | undefined;
  onChange: (value: Date | undefined) => void;
}) {
  const accountFinancialYears = useGetAccountFinancialYearsData();

  const presetDates: DatePreset[] | undefined =
    accountFinancialYears.data && accountFinancialYears.data.length > 1 ?
      [
        {
          key: "today",
          label: "Today",
          date: new Date(),
        },
        ...accountFinancialYears.data
          .filter((fy) => fy.endDate < new Date()) // no future dates
          .map((fy) => ({
            key: `fy-${fy.endDate.getFullYear()}`,
            label: `30 June ${fy.endDate.getFullYear()}`,
            date: startOfDayInTimeZone(fy.endDate, AccountTimeZone),
          })),
      ]
    : undefined;

  return (
    <VStack alignItems="flex-start">
      <Text>Date</Text>

      <Box backgroundColor="white">
        <DatePicker
          showTime={false}
          value={date ?? undefined}
          onChange={onChange}
          presetTitle="Select end of financial year"
          presetDates={presetDates}
          // it would be nicer if this set to the
          // earliest transaction in the portfolio
          earliestDate={SYLA_EARLIEST_EVENT_DATE}
          latestDate={startOfDayInTimeZone(new Date(), AccountTimeZone)}
          timeZone={AccountTimeZone}
        />
      </Box>
    </VStack>
  );
}
